(function () {
    let a = document.querySelector("meta[name=viewport]");
    let b = "orientationchange" in window ? "orientationchange" : "resize";
    let d = function () {
        let f = document.body || document.documentElement;
        let e = f.clientWidth;
        return e / 10
    };
    let c = function () {
        document.getElementsByTagName("html")[0].setAttribute("style", "font-size:" + d() + "px !important")
    };

    a.setAttribute("content", "width=device-width,initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no");
    c();
    window.addEventListener(b, c, false)
})();